import { HTMLProps, PropsWithChildren } from "react";
import { Box, Grid, Slider, Typography } from "@mui/material";
import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";

import { CommonFieldProps } from "./types";

interface Props<T extends FieldValues> extends CommonFieldProps<T>, HTMLProps<HTMLInputElement> {
    control: Control<T, any>;
    label: string;
}

const FieldSlider: React.FunctionComponent<Props<any>> = <TObject extends FieldValues>({
    control,
    fieldName,
    label,
    children,
}: PropsWithChildren<Props<TObject>>) => (
    <Controller
        name={fieldName}
        control={control}
        defaultValue={0 as PathValue<TObject, Path<TObject>>}
        render={({ field }) => (
            <Box>
                <Typography id="input-slider" gutterBottom>{label}</Typography>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs>
                        <Slider
                            {...field}
                            onChange={(_, value) => {
                                field.onChange(value);
                            }}
                            valueLabelDisplay="auto"
                            step={1}
                            color='secondary'
                        />
                    </Grid>
                </Grid>
            </Box>
        )}
    />
);

export default FieldSlider;